module.exports = __webpack_public_path__ + "static/media/our-products.a6a47b7c.jpg";